<template>
    <div slot="grid-actions">
        <modal id="import" ref="import" @hide="resetState">
            <template slot="title">{{ t('clientsImportOrders-title') }}</template>
            <template slot="body">
                <div class="field">
                    <label
                        >{{ t('clientsImportOrders-upload_label') }}
                        <a
                            href="https://gokevi.notion.site/Central-de-Ajuda-5812ca0617604dfc9ef3da34d9727b87#a20dc181142743e782cb421a648137c5"
                            >({{ t('clientsImportOrders-help_center') }})</a
                        ></label
                    >
                    <input
                        type="file"
                        name="csv"
                        accept=".csv"
                        @change="upload"
                    />
                </div>
                <div class="field">
                    <label>{{ t('clientsImportOrders-select_branch') }}</label>
                    <select v-model="branch_id">
                        <option
                            v-for="branch in branches"
                            :key="branch.id"
                            :value="branch.id"
                        >
                            {{ branch.title }}
                        </option>
                    </select>
                </div>
                <div class="field">
                    <label
                        ><input type="checkbox" v-model="oneRowPerProduct" />
                        {{ t('clientsImportOrders-one_row_per_product') }}
                    </label>
                </div>
                <template v-if="step === 'loading'">
                    <span class="far loader fa-spinner fa-spin fa-3x"></span>
                    {{ t('clientsImportOrders-loading_message') }}
                </template>
                <template v-show="step === 'upload' || step === 'preview'">
                    <template v-if="!isFileSizeValid">
                        <div class="alert alert-danger">
                            {{ t('clientsImportOrders-file_size_error', [maxFileSize]) }}
                        </div>
                    </template>
                    <template v-if="csvErrors">
                        <div class="alert alert-danger">
                            {{ t('clientsImportOrders-csv_error') }}
                        </div>
                    </template>
                    <div
                        class="field field-columns"
                        v-if="step === 'upload' && headerRow.length"
                    >
                        <div v-if="!orderIdMapped" class="alert alert-warning">
                            {{ t('clientsImportOrders-order_id_required') }}
                        </div>
                        <table class="column-table table table-striped">
                            <tr
                                v-for="(col, id) in config.main_column"
                                v-show="
                                    col.show === undefined ||
                                    col.show(config, module, oneRowPerProduct)
                                "
                                :key="id"
                            >
                                <td>
                                    <span
                                        :class="{
                                            required:
                                                typeof col.required ===
                                                'function'
                                                    ? col.required(
                                                          config,
                                                          oneRowPerProduct,
                                                      )
                                                    : col.required,
                                        }"
                                    >
                                        {{ columnLabels[id] }}
                                    </span>
                                </td>
                                <td>
                                    <select
                                        v-model="
                                            config.main_column[id][
                                                'mapped_column'
                                            ]
                                        "
                                        class="form-control"
                                    >
                                        <option value=""></option>
                                        <option
                                            v-for="(colCSV, index) in headerRow"
                                            :key="index"
                                        >
                                            {{ colCSV }}
                                        </option>
                                    </select>
                                </td>
                                <td class="extra">
                                    <div
                                        class="field-extra"
                                        v-if="
                                            col.extra.include_time !== undefined
                                        "
                                    >
                                        <div>
                                            <label
                                                ><input
                                                    type="checkbox"
                                                    v-model="
                                                        col.extra.include_time
                                                    "
                                                />
                                                {{ t('clientsImportOrders-include_time') }}</label
                                            >
                                        </div>
                                    </div>
                                    <div
                                        class="field-extra"
                                        v-if="col.extra.format !== undefined"
                                    >
                                        <div><label>{{ t('clientsImportOrders-format') }}</label></div>
                                        <div>
                                            <input
                                                class="form-control"
                                                type="text"
                                                v-model="col.extra.format"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="field-extra"
                                        v-if="
                                            col.extra.decimal_separator !==
                                            undefined
                                        "
                                    >
                                        <div>
                                            <label>{{ t('clientsImportOrders-decimal_separator') }}</label>
                                        </div>
                                        <div>
                                            <input
                                                class="form-control"
                                                type="text"
                                                v-model="
                                                    col.extra.decimal_separator
                                                "
                                                maxlength="1"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="field-extra"
                                        v-if="
                                            col.extra.is_full_name !== undefined
                                        "
                                    >
                                        <div>
                                            <label
                                                ><input
                                                    type="checkbox"
                                                    v-model="
                                                        col.extra.is_full_name
                                                    "
                                                />
                                                {{ t('clientsImportOrders-full_name') }}</label
                                            >
                                        </div>
                                    </div>
                                    <div
                                        class="field-extra"
                                        v-if="
                                            col.extra.default_prefix !==
                                            undefined
                                        "
                                    >
                                        <div><label>{{ t('clientsImportOrders-default_prefix') }}</label></div>
                                        <div>
                                            <input
                                                class="form-control"
                                                type="text"
                                                v-model="
                                                    col.extra.default_prefix
                                                "
                                                maxlength="3"
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr
                                v-for="(col, id) in config.order_custom_fields"
                                :key="id"
                            >
                                <td>{{ fieldLabel(id) }}</td>
                                <td>
                                    <select
                                        v-model="
                                            config.order_custom_fields[id][
                                                'mapped_column'
                                            ]
                                        "
                                        class="form-control"
                                    >
                                        <option value=""></option>
                                        <option
                                            v-for="(colCSV, index) in headerRow"
                                            :value="colCSV"
                                            :key="index"
                                        >
                                            {{ colCSV }}
                                        </option>
                                    </select>
                                </td>
                                <td></td>
                            </tr>
                        </table>
                    </div>
                    <div v-if="step === 'preview'">
                        <table class="table table-preview">
                            <thead>
                                <tr>
                                    <td
                                        v-for="(col, idx) in columnLabels"
                                        v-show="
                                            !config.main_column[idx] ||
                                            !config.main_column[idx]
                                                .product_column
                                        "
                                        :key="idx"
                                    >
                                        {{ col }}
                                    </td>
                                    <td
                                        v-if="oneRowPerProduct"
                                        style="min-width: 300px"
                                    >
                                        {{ t('clientsImportOrders-products') }}
                                    </td>
                                    <td
                                        v-for="(field, index) in fields"
                                        :key="index"
                                    >
                                        {{ field.field_name }}
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(row, index) in preview"
                                    :key="index"
                                >
                                    <td
                                        v-for="(col, idx) in columnLabels"
                                        v-show="
                                            !config.main_column[idx] ||
                                            !config.main_column[idx]
                                                .product_column
                                        "
                                        :key="idx"
                                    >
                                        {{ row[idx] }}
                                    </td>
                                    <td v-if="oneRowPerProduct">
                                        <div
                                            v-for="(
                                                product, index
                                            ) in row.products"
                                            class="product-preview"
                                            :key="index"
                                        >
                                            <strong>
                                                {{ product.quantity }}x -
                                                {{ product.product_name }}
                                                <br />
                                            </strong>
                                            <span v-if="product.brand"
                                                >{{ t('clientsImportOrders-brand') }}: {{ product.brand }} <br
                                            /></span>
                                            <span v-if="product.category"
                                                >{{ t('clientsImportOrders-category') }}:
                                                {{ product.category }} <br
                                            /></span>
                                            <span v-if="product.price"
                                                >{{ t('clientsImportOrders-price') }}: {{ currencySymbol }}{{ product.price }}
                                                <br
                                            /></span>
                                            <span v-if="product.cost"
                                                >{{ t('clientsImportOrders-cost') }}: {{ currencySymbol }}{{ product.cost }}
                                                <br
                                            /></span>
                                        </div>
                                    </td>
                                    <td v-for="field in fields" :key="field.id">
                                        {{
                                            row["order_fields"][field.id]
                                                ? row["order_fields"][field.id]
                                                : ""
                                        }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="step === 'queued'" class="text-center py-3">
                        <span class="far fa-check-circle fa-3x text-success"></span>
                        <p class="mt-3">{{ t('clientsImportOrders-queued_message') }}</p>
                        <router-link to="/imports" @click.native="$refs.import.close()">
                            {{ t('clientsImportOrders-queued_link') }}
                        </router-link>
                    </div>
                    <div v-if="step === 'success'">
                        <table class="table">
                            <tr>
                                <td>{{ t('clientsImportOrders-summary-new_clients') }}</td>
                                <td>{{ newClients }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('clientsImportOrders-summary-new_orders') }}</td>
                                <td>{{ newOrders }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('clientsImportOrders-summary-updated_status') }}</td>
                                <td>{{ updatedStatus }}</td>
                            </tr>
                            <tr>
                                <td>
                                    {{ t('clientsImportOrders-summary-already_imported') }}
                                </td>
                                <td>{{ alreadyImported }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('clientsImportOrders-summary-failed_rows') }}</td>
                                <td>
                                    {{ failedRowsCount }}
                                    <a
                                        v-if="failedRowsCount > 0"
                                        href="#"
                                        @click.prevent="downloadFailedRows"
                                        >{{ t('clientsImportOrders-download_csv') }}</a
                                    >
                                </td>
                            </tr>
                        </table>
                    </div>
                </template>
            </template>
            <template slot="footer">
                <template v-if="step === 'upload'">
                    <button
                        class="btn btn-success"
                        @click="
                            step = 'upload';
                            $refs.import.close();
                        "
                    >
                        {{ t('clientsImportOrders-cancel') }}
                    </button>
                    <button
                        class="btn btn-success"
                        :disabled="!isValid"
                        @click="previewRows()"
                    >
                        {{ t('clientsImportOrders-next') }}
                    </button>
                </template>
                <template v-if="step === 'preview'">
                    <button class="btn btn-success" @click="step = 'upload'">
                        {{ t('clientsImportOrders-back') }}
                    </button>
                    <button
                        class="btn btn-success"
                        :disabled="!isValid"
                        @click="importOrders()"
                    >
                        {{ t('clientsImportOrders-import') }}
                    </button>
                </template>
                <template v-if="step === 'queued'">
                    <button
                        class="btn btn-success"
                        @click="
                            step = 'upload';
                            $refs.import.close();
                        "
                    >
                        {{ t('clientsImportOrders-close') }}
                    </button>
                </template>
                <template v-if="step === 'success'">
                    <button
                        class="btn btn-success"
                        @click="
                            step = 'upload';
                            $refs.import.close();
                        "
                    >
                        {{ t('clientsImportOrders-close') }}
                    </button>
                </template>
            </template>
        </modal>
        <slot>
            <button class="btn btn-success" @click="$refs.import.open()">
                {{ t('clientsImportOrders-open_button') }}
            </button>
        </slot>
    </div>
</template>
<script>
import keviApi from "../keviApi.js";
import Papa from "papaparse";
import { mapGetters } from "vuex";
export default {
    data: () => {
        return {
            branch_id: null,
            step: "upload",
            file: null,
            maxFileSize: 50, //In MB
            rows: [],
            headerRow: [],
            csvErrors: false,
            parsed: false,
            result: {},
            preview: [],
            fields: [],
            newClients: 0,
            newOrders: 0,
            updatedStatus: 0,
            failedRowsCount: 0,
            alreadyImported: 0,
            failedRows: {},
            oneRowPerProduct: false,
            importHistoryId: null,
            config: {
                main_column: {
                    external_id: {
                        mapped_column: "",
                        /**
                         * The order id is always required: it is what deduplicates rows
                         * into orders (and groups products when one row per product).
                         * Without it every row collapses into generated ids.
                         */
                        required: true,
                        extra: {},
                    },
                    product_external_id: {
                        product_column: true,
                        mapped_column: "",
                        required: function (c, oneRowPerProduct) {
                            return oneRowPerProduct;
                        },
                        extra: {},
                        show: function (c, m, oneRowPerProduct) {
                            return !!oneRowPerProduct;
                        },
                    },
                    product_name: {
                        product_column: true,
                        mapped_column: "",
                        required: function (c, oneRowPerProduct) {
                            return oneRowPerProduct;
                        },
                        extra: {},
                        show: function (c, m, oneRowPerProduct) {
                            return !!oneRowPerProduct;
                        },
                    },
                    quantity: {
                        product_column: true,
                        mapped_column: "",
                        required: false,
                        extra: {},
                        show: function (c, m, oneRowPerProduct) {
                            return !!oneRowPerProduct;
                        },
                    },
                    category: {
                        product_column: true,
                        mapped_column: "",
                        required: false,
                        extra: {},
                        show: function (c, m, oneRowPerProduct) {
                            return !!oneRowPerProduct;
                        },
                    },
                    brand: {
                        product_column: true,
                        mapped_column: "",
                        required: false,
                        extra: {},
                        show: function (c, m, oneRowPerProduct) {
                            return !!oneRowPerProduct;
                        },
                    },
                    price: {
                        product_column: true,
                        mapped_column: "",
                        required: false,
                        extra: {
                            decimal_separator: ",",
                        },
                        show: function (c, m, oneRowPerProduct) {
                            return !!oneRowPerProduct;
                        },
                    },
                    cost: {
                        product_column: true,
                        mapped_column: "",
                        required: false,
                        extra: {
                            decimal_separator: ",",
                        },
                        show: function (c, m, oneRowPerProduct) {
                            return !!oneRowPerProduct;
                        },
                    },
                    client_external_id: {
                        mapped_column: "",
                        required: function (columns) {
                            return (
                                columns.main_column.whatsapp.mapped_column ===
                                ""
                            );
                        },
                        extra: {},
                    },
                    first_name: {
                        mapped_column: "",
                        required: false,
                        extra: {
                            is_full_name: false,
                        },
                    },
                    last_name: {
                        mapped_column: "",
                        required: false,
                        extra: {},
                        show: function (columns) {
                            return !columns.main_column.first_name.extra
                                .is_full_name;
                        },
                    },
                    whatsapp: {
                        mapped_column: "",
                        required: function (columns) {
                            return (
                                columns.main_column.client_external_id
                                    .mapped_column === ""
                            );
                        },
                        extra: {
                            default_prefix: "",
                        },
                    },
                    email: {
                        mapped_column: "",
                        required: false,
                        extra: {},
                    },
                    birthdate: {
                        mapped_column: "",
                        required: true,
                        extra: {
                            format: "d/m/Y",
                        },
                    },
                    date: {
                        mapped_column: "",
                        required: true,
                        extra: {
                            format: "d/m/Y",
                            include_time: false,
                        },
                    },
                    time: {
                        mapped_column: "",
                        required: function (columns) {
                            return !columns.main_column.date.include_time;
                        },
                        extra: {},
                        show: function (columns) {
                            return !columns.main_column.date.extra.include_time;
                        },
                    },
                    value: {
                        mapped_column: "",
                        required: true,
                        extra: {
                            decimal_separator: ",",
                        },
                    },
                    external_status: {
                        mapped_column: "",
                        required: false,
                        extra: {},
                        show: (columns, module) => {
                            return module("order_status");
                        },
                    },
                },
                order_custom_fields: {},
            },
        };
    },
    computed: {
        headerHash() {
            return this.simpleHash(this.headerRow.join(", "));
        },
        groupedRows() {
            if (!this.rows || this.rows.length === 0) {
                return [];
            }
            let columns = [];
            for (let c in this.config.main_column) {
                columns.push(this.config.main_column[c].mapped_column);
            }
            for (let co in this.config.order_custom_fields) {
                columns.push(this.config.order_custom_fields[co].mapped_column);
            }
            let cleanRow = (row) => {
                let strippedRow = {};
                columns.forEach((c) => {
                    if (c) {
                        strippedRow[c] = row[c];
                    }
                });
                return strippedRow;
            };
            const rows = this.rows.map(cleanRow);
            if (!this.oneRowPerProduct) {
                return rows;
            }
            if (
                this.oneRowPerProduct &&
                !this.config.main_column.external_id.mapped_column
            ) {
                return [];
            }

            //Group rows by order and includ product as an array of objects
            const orders = {};
            const productColumns = [];
            for (let c in this.config.main_column) {
                if (this.config.main_column[c].product_column) {
                    productColumns.push(
                        this.config.main_column[c].mapped_column,
                    );
                }
            }
            let getProduct = (row) => {
                let productRow = {};
                productColumns.forEach((c) => {
                    if (c) {
                        productRow[c] = row[c];
                    }
                });
                return productRow;
            };
            const externalIdColumn =
                this.config.main_column["external_id"].mapped_column;
            rows.forEach((row) => {
                if (orders[row[externalIdColumn]] === undefined) {
                    orders[row[externalIdColumn]] = row;
                    orders[row[externalIdColumn]]["products"] = [];
                }
                orders[row[externalIdColumn]]["products"].push(getProduct(row));
            });
            return Object.values(orders);
        },
        isFileSizeValid() {
            return this.file
                ? this.file.size <= this.maxFileSize * 1024 * 1024
                : true;
        },
        orderIdMapped() {
            return !!this.config.main_column.external_id.mapped_column;
        },
        isValid() {
            if (
                this.isFileSizeValid &&
                !this.csvErrors &&
                this.rows.length > 0 &&
                this.orderIdMapped
            ) {
                return true;
            }
            return false;
        },
        branches() {
            return this.$store.state.place.branches;
        },
        columnLabels() {
            return {
                external_id: this.t("clientsImportOrders-columns-external_id"),
                client_external_id: this.t("clientsImportOrders-columns-client_external_id"),
                date: this.t("clientsImportOrders-columns-date"),
                time: this.t("clientsImportOrders-columns-time"),
                value: this.t("clientsImportOrders-columns-value"),
                first_name: this.t("clientsImportOrders-columns-first_name"),
                last_name: this.t("clientsImportOrders-columns-last_name"),
                whatsapp: this.t("clientsImportOrders-columns-whatsapp"),
                email: this.t("clientsImportOrders-columns-email"),
                birthdate: this.t("clientsImportOrders-columns-birthdate"),
                external_status: this.t("clientsImportOrders-columns-external_status"),
                status: this.t("clientsImportOrders-columns-status"),
                product_external_id: this.t("clientsImportOrders-columns-product_external_id"),
                product_name: this.t("clientsImportOrders-columns-product_name"),
                category: this.t("clientsImportOrders-columns-category"),
                brand: this.t("clientsImportOrders-columns-brand"),
                price: this.t("clientsImportOrders-columns-price"),
                cost: this.t("clientsImportOrders-columns-cost"),
                quantity: this.t("clientsImportOrders-columns-quantity"),
            };
        },
        ...mapGetters(["module"]),
    },
    mounted() {
      window.setTimeout(() => {
        this.loadFields();
      }, 300);
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        simpleHash(string) {
            let hash = 0;
            for (let i = 0; i < string.length; i++) {
                const char = string.charCodeAt(i);
                hash = (hash << 5) - hash + char;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        },
        loadFields() {
            let options = keviApi.getOptions("/order-fields", "GET");
            this.$http(options).then((response) => {
                this.fields = JSON.parse(JSON.stringify(response.body));
                this.config.order_custom_fields = {};
                this.fields.forEach((field) => {
                    this.config.order_custom_fields[field.id] = {
                        mapped_column: "",
                        required: false,
                        extra: {},
                    };
                });
            });
        },
        fieldLabel(id) {
            const field = this.fields.find((f) => String(f.id) === String(id));
            return field ? field.field_name : "";
        },

        upload(file) {
            this.file = file.target.files[0] || null;
            if (this.isFileSizeValid) {
                this.prepareDemo();
            }
        },
        previewRows() {
            localStorage.setItem(
                "importer_config_" + this.headerHash,
                JSON.stringify({
                    config: this.config,
                    oneRowPerProduct: this.oneRowPerProduct,
                }),
            );
            let options = keviApi.getOptions(
                "importer/preview-orders",
                "POST",
                {
                    rows: this.groupedRows.slice(0, 20),
                    config: this.config,
                },
            );
            this.step = "loading";

            this.$http(options).then(function (response) {
                if (response.status === 200) {
                    this.step = "preview";
                    this.preview = response.body.preview;
                }
            });
        },
        importOrders() {
            let options = keviApi.getOptions("importer/import-orders", "POST", {
                rows: this.groupedRows,
                branch_id: this.branch_id,
                config: this.config,
                filename: this.file ? this.file.name : null,
            });
            this.step = "loading";

            this.$http(options).then(function (response) {
                // The import now runs in the background: the request only enqueues
                // the job and returns 202 with the created history id.
                if (response.status === 202) {
                    this.step = "queued";
                    this.importHistoryId = response.body.import_history_id;
                    this.$emit("queued", this.importHistoryId);
                } else if (response.status === 200) {
                    this.step = "success";
                    this.newOrders = response.body.newOrders;
                    this.newClients = response.body.newClients;
                    this.alreadyImported = response.body.alreadyImported;
                    this.failedRows = response.body.failedRows;
                    this.updatedStatus = response.body.updatedStatus;
                    this.failedRowsCount = response.body.failedRowsCount;
                }
            });
        },
        prepareDemo() {
            this.csvErrors = false;
            this.headerRow = [];
            this.parsed = false;
            Papa.parse(this.file, {
                header: true,
                delimiter: "",
                skipEmptyLines: true,
                complete: (results) => {
                    if (results.errors.length > 0) {
                        this.csvErrors = true;
                    } else {
                        this.parsed = true;
                        this.headerRow = Object.keys(results.data[0]).sort();
                        this.rows = results.data;
                    }
                },
            });
        },
        download(filename, text) {
            const element = document.createElement("a");
            element.setAttribute(
                "href",
                "data:text/plain;charset=utf-8," + encodeURIComponent(text),
            );
            element.setAttribute("download", filename);

            element.style.display = "none";
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },
        downloadFailedRows() {
            const data = Papa.unparse(this.failedRows);
            this.download("error.csv", data);
        },
        resetState() {
            this.step = "upload";
            this.file = null;
            this.rows = [];
            this.headerRow = [];
            this.csvErrors = false;
            this.parsed = false;
            this.result = {};
            this.preview = [];
            this.newClients = 0;
            this.newOrders = 0;
            this.updatedStatus = 0;
            this.failedRowsCount = 0;
            this.alreadyImported = 0;
            this.failedRows = {};
            this.oneRowPerProduct = false;
            this.branch_id = null;
            this.importHistoryId = null;

            for (let c in this.config.main_column) {
                this.config.main_column[c].mapped_column = "";
            }

            for (let co in this.config.order_custom_fields) {
                this.config.order_custom_fields[co].mapped_column = "";
            }

            if (this.config.main_column.first_name?.extra) {
                this.config.main_column.first_name.extra.is_full_name = false;
            }
            if (this.config.main_column.whatsapp?.extra) {
                this.config.main_column.whatsapp.extra.default_prefix = "";
            }
            if (this.config.main_column.birthdate?.extra) {
                this.config.main_column.birthdate.extra.format = "d/m/Y";
            }

            if (this.config.main_column.date?.extra) {
                this.config.main_column.date.extra.format = "d/m/Y";
                this.config.main_column.date.extra.include_time = false;
            }
            if (this.config.main_column.value?.extra) {
                this.config.main_column.value.extra.decimal_separator = ",";
            }

            if (this.config.main_column.price?.extra) {
                this.config.main_column.price.extra.decimal_separator = ",";
            }
            if (this.config.main_column.cost?.extra) {
                this.config.main_column.cost.extra.decimal_separator = ",";
            }

            const fileInput = document.querySelector('#import input[type="file"]');
            if (fileInput) {
                fileInput.value = '';
            }
        },
    },
    watch: {
        headerRow() {
            let savedConfig = localStorage.getItem(
                "importer_config_" + this.headerHash,
            );
            if (savedConfig) {
                savedConfig = JSON.parse(savedConfig);
                if (savedConfig.config) {
                    // localStorage only stores JSON, so the show/required closures on
                    // this.config are gone in the saved copy. Merge just the serializable
                    // state (mapped columns + extra settings) so the function-based column
                    // visibility (e.g. product columns only when "one row per product") is
                    // preserved instead of being wiped to `undefined`.
                    const saved = savedConfig.config;
                    if (saved.main_column) {
                        for (let c in this.config.main_column) {
                            const savedColumn = saved.main_column[c];
                            if (!savedColumn) {
                                continue;
                            }
                            this.config.main_column[c].mapped_column =
                                savedColumn.mapped_column || "";
                            if (savedColumn.extra) {
                                this.config.main_column[c].extra = {
                                    ...this.config.main_column[c].extra,
                                    ...savedColumn.extra,
                                };
                            }
                        }
                    }
                    if (saved.order_custom_fields) {
                        for (let co in this.config.order_custom_fields) {
                            const savedField = saved.order_custom_fields[co];
                            if (!savedField) {
                                continue;
                            }
                            this.config.order_custom_fields[co].mapped_column =
                                savedField.mapped_column || "";
                        }
                    }
                    this.oneRowPerProduct = savedConfig.oneRowPerProduct;
                }
            } else {
                let clean = (c) => c.toLowerCase().replace(/[^A-z]/, "");
                let columns = this.headerRow.map(clean);
                let mappedHeader = {};
                for (let c in columns) {
                    mappedHeader[columns[c]] = this.headerRow[c];
                }
                for (let c in this.config.main_column) {
                    let cName = clean(this.columnLabels[c]);
                    this.config.main_column[c].mapped_column =
                        mappedHeader[cName] || "";
                }
                for (let co in this.config.order_custom_fields) {
                    let coName = clean(this.fieldLabel(co));
                    this.config.order_custom_fields[co].mapped_column =
                        mappedHeader[coName] || "";
                }
            }
        },
    },
};
</script>
<style scoped lang="scss">
.field {
    margin-top: 20px;

    label {
        font-size: 14px;
        font-weight: 500;
    }
}

table td {
    font-size: 12px;
    padding: 6px;
    vertical-align: middle;
    .required {
        font-weight: 600;
        &:after {
            content: "*";
        }
    }
    select,
    input {
        margin-top: 0;
    }
    &.extra {
        .field-extra {
            display: inline-block;
            margin-right: 20px;
            label {
                margin-bottom: 5px;
            }
        }
    }
}

.table-preview td {
    min-width: 150px;
}

.product-preview {
    font-size: 10px;
    margin-bottom: 10px;
}

::v-deep {
    .modal-dialog {
        max-width: 800px;
    }
}
</style>
